/**
 * Family module Vuex state.
 *
 * Holds:
 *   - the list of the current user's families (cards list in Portfolio tab)
 *   - the active family + its subgraph (members, relationships, photos, face crops, view)
 *   - transient UI state (wizard open, selected member, etc.)
 *
 * Types are loosely-typed (`any[]`) in MVP so they compile before GraphQL codegen runs.
 * Replace with generated types from src/generated/nexus-graphql/family.ts once codegen runs.
 */

export interface FamilyState {
  // Portfolio tab: list of families user has access to
  families: any[];
  familiesLoading: boolean;
  familiesError: string | null;

  // Active family being viewed/edited
  activeFamilyId: string | null;
  activeSubgraph: {
    familyName: string;
    viewerCanEdit: boolean;
    view: any | null;
    members: any[];
    relationships: any[];
    photos: any[];
    faceCrops: any[];
  } | null;
  activeSubgraphLoading: boolean;
  activeSubgraphError: string | null;

  // Transient UI: which member is focused on the canvas, etc.
  selectedMemberId: string | null;
  wizardOpen: boolean;

  // Public view (share token flow) — independent from active family context
  publicSubgraph: {
    familyName: string;
    viewerCanEdit: boolean;
    view: any | null;
    members: any[];
    relationships: any[];
    photos: any[];
    faceCrops: any[];
  } | null;
  publicSubgraphLoading: boolean;
  publicSubgraphError: string | null;
}

const state: FamilyState = {
  families: [],
  familiesLoading: false,
  familiesError: null,

  activeFamilyId: null,
  activeSubgraph: null,
  activeSubgraphLoading: false,
  activeSubgraphError: null,

  selectedMemberId: null,
  wizardOpen: false,

  publicSubgraph: null,
  publicSubgraphLoading: false,
  publicSubgraphError: null
};

export default state;
